import React  from 'react'

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import {SystemStatus} from "../../../../../../../core/gd/const/system-status"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import CustomView_rowComponent from "./row-component"

// @ts-ignore
import SelectMultiGeneric from "../../../../../../../core/gd-ui/select-multi-generic/select-multi-generic"

type Props = {
    form            : FormManager
    formFieldName   : string

    disabled?       : boolean
}

export default function SelectTaskSystemStatusMulti(props: Props) {
    const systemTaskStatusOptions = [
        SystemStatus.NOT_STARTED,
        SystemStatus.IN_PROGRESS,
        SystemStatus.IN_REVIEW,
        SystemStatus.ON_HOLD,
        SystemStatus.COMPLETED,
        SystemStatus.CANCELLED
    ].map(s=>({value: s, label: gd.const.systemStatusList[s]}))

    return (
        <CustomView_rowComponent label="Task system status">
            <SelectMultiGeneric form            = {props.form}
                                name            = {props.formFieldName}
                                options         = {systemTaskStatusOptions}
                                renderValue     = "form"
                                placeholder     = {"All task statuses"}
                                canHaveNoValue  = {true}
                                noValueValue    = {[]}
                                noValueLabel    = "All task statuses"
                                searchable      = {false}
                                disabled        = {props.disabled}/>
            <FormError form = {props.form}
                       name = {props.formFieldName} />
        </CustomView_rowComponent>
    )
}

SelectTaskSystemStatusMulti.defaultProps = {
    formFieldName   : "systemTaskStatuses",
}